export const LIST_ADVERTISING_INITIAL = 'LIST_ADVERTISING_INITIAL'
export const GET_BANNER_ID = 'GET_BANNER_ID'
export const GET_CONFIG_TIME_SLIDER = 'GET_CONFIG_TIME_SLIDER'
export const LOADING_SLIDER = 'LOADING_SLIDER'